import CalendarCommunicationSettings from '@/entities/CalendarCommunicationSettings'

import { CALENDAR_TYPES } from '@/views/constants'

/*
 locations that are borrowed from other calendar
 this data collects  only if calendar "availability_as" settings set to "other calendar"
 not used yet, and probably will not be used
 cause even with "other calendar" availability original calendar locations used
 */
export default class CalendarBorrowedLocations {
  constructor (calendarType = CALENDAR_TYPES.PRACTICE_TYPE, communicationSettings = new CalendarCommunicationSettings(), calendarIndexToLocationAndProviderMap = {}, calendarIdToIndexMap = {}) {
    this.list = []
    this.current = null
    if ([CALENDAR_TYPES.PROVIDER_LOCATION_TYPE, CALENDAR_TYPES.PROVIDER_TYPE].includes(calendarType) &&
      communicationSettings.availabilityCalendarId) {
      const otherCalendarIndex = calendarIdToIndexMap[communicationSettings.availabilityCalendarId]
      if (otherCalendarIndex) {
        this.list = [
          ...calendarIndexToLocationAndProviderMap[otherCalendarIndex]?.original?.allLocations?.list || []
        ]
        this.current = calendarIndexToLocationAndProviderMap[otherCalendarIndex]?.original?.allLocations?.current || null
      }
    }
  }
}
